"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Video, Camera, Calendar, Package, Instagram, Film } from "lucide-react";
export default function OurServicesPreview() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref5,
    isVisible: isVisible5
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref6,
    isVisible: isVisible6
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Video,
    title: "Video Production",
    description: "Cinematic storytelling with pre-production, filming, editing, color grading, and sound design.",
    ref: ref1,
    isVisible: isVisible1
  }, {
    icon: Camera,
    title: "Photography",
    description: "Studio and on-location shoots for products, portraits, and corporate imagery.",
    ref: ref2,
    isVisible: isVisible2
  }, {
    icon: Calendar,
    title: "Event Coverage",
    description: "Comprehensive photo and video packages capturing your most important moments.",
    ref: ref3,
    isVisible: isVisible3
  }, {
    icon: Package,
    title: "Product Shoots",
    description: "High-impact product photography that showcases quality and drives conversions.",
    ref: ref4,
    isVisible: isVisible4
  }, {
    icon: Instagram,
    title: "Social Media Content",
    description: "Reels, TikTok, and Snapchat formats optimized for engagement and reach.",
    ref: ref5,
    isVisible: isVisible5
  }, {
    icon: Film,
    title: "Post-Production",
    description: "Expert editing, color grading, and light motion graphics to perfect your content.",
    ref: ref6,
    isVisible: isVisible6
  }];
  return <section id="our-services-preview" className="py-24 px-6 md:px-12 lg:px-24 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We create high-impact content that looks expensive, feels emotional, and converts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Link to="/ServicesPage" key={i} data-index={i} className="block group">
                <div ref={service.ref} className={`transition-all duration-[var(--duration-medium)] ${service.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
              transitionDelay: `${i * 100}ms`
            }}>
                  <Card className="h-full border border-border hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] px-6">
                    <CardHeader className="px-0">
                      <div className="mb-4 inline-block group-hover:shadow-[0_0_20px_rgba(218,165,32,0.4)] transition-shadow duration-[var(--duration-medium)] ease-[var(--ease-out-back)] rounded-full p-3 bg-accent-light">
                        <IconComponent className="w-8 h-8 text-accent" />
                      </div>
                      <CardTitle className="text-xl font-display font-semibold text-foreground">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="px-0">
                      <CardDescription className="text-muted-foreground leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </CardContent>
                  </Card>
                </div>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}